import React, { FunctionComponent, useState } from 'react';
import withStyles from 'react-jss';
import { useParams } from 'react-router-dom';
import { propOr, findIndex, pathEq, isEmpty } from 'ramda';
import { useQuery } from 'react-apollo';
import { Container, Grid } from 'semantic-ui-react';

import Table from 'components/Table';
import Query from 'components/Query';
import { ClassProp } from 'helpers/types';
import { GET_PROFILE } from 'components/UserMgmt/UserMgmt.queries';
import { ChartPlaceholder } from 'components/Placeholder';

import BudgetAdjustments from './components/BudgetAdjustments';
import { CampaignSummary, getTableHeader } from './MerchantCampaigns.helpers';
import GET_MERCHANT_CAMPAIGNS_RESULTS from './MerchantCampaigns.queries';

export type QueryResponse = {
  data: {
    campaignFindBy: {
      campaignSummary: CampaignSummary[];
    };
  };
  loading: boolean;
  error: any;
};

const styles = {
  container: {
    margin: '1.25rem auto !important',
    height: '100% !important',
  },
  header: {},
};

type Styles = ClassProp<typeof styles>;
type Props = {
  classes: Styles;
};

const renderCampaigns = (
  classes: Styles,
  rowNumber: number,
  setRowNumber: React.Dispatch<React.SetStateAction<number>>,
) => ({ data, loading }: QueryResponse) => {
  if (loading) {
    return (
      <Container className={classes.container}>
        <ChartPlaceholder />
      </Container>
    );
  }

  const { campaignFindBy } = data;
  const tableHeader = getTableHeader();
  if (isEmpty(campaignFindBy)) {
    return (
      <div>
        <h2 className={classes.header}>
          No Campaigns were found for this Merchant
        </h2>
      </div>
    );
  }

  const selectedRowHandler = (rowId: string) => {
    const index = findIndex(
      pathEq(['campaign', 'uuid'], rowId),
      campaignFindBy as any,
    );
    setRowNumber(index);
  };

  return (
    <Container className={classes.container}>
      <Grid container>
        <Table
          tableHeader={tableHeader}
          data={campaignFindBy as any}
          selectedrowCallback={selectedRowHandler}
          expandedViewComponent={
            <BudgetAdjustments
              campaignSummary={campaignFindBy as any}
              selectedRowIndex={rowNumber}
            />
          }
        />
      </Grid>
    </Container>
  );
};

const MerchantCampaigns: FunctionComponent<Props> = ({ classes }) => {
  const [rowNumber, setRowNumber] = useState<number>(0);
  const routeParams = useParams();

  const profilePayload = useQuery(GET_PROFILE);
  const { userProfile } = profilePayload.data;

  const params = {
    advertiserMerchantUuid: propOr(
      userProfile.merchantId,
      'merchantId',
      routeParams,
    ),
  };

  return (
    <Query
      enableProgressInfo
      query={GET_MERCHANT_CAMPAIGNS_RESULTS}
      render={renderCampaigns(classes, rowNumber, setRowNumber)}
      variables={{
        params,
      }}
    />
  );
};

export default withStyles(styles)(MerchantCampaigns);
